import { Button, Col, Collapse, DatePicker, Divider, Form, Modal, Radio, Row, Space, Tag, message, Checkbox } from 'antd';
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import { CheckCircleOutlined, CloseCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { getStatusColor, handleShowTYPE, handleShowTypeReply } from '../hook/function';
import { baseUrlAREA, CONFIRM_LETTER, HEADERS_BASIC } from '../../../API/apiUrlsNew';

function ConfirmLetter({ open, close, data, loadData, setDayData }) {

    const [formList, setFormList] = useState(data?.length > 0 ? data : []);
    const [loading, setLoading] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]); // เก็บ ID ที่ถูกเลือก

    // console.log("data", data)

    // useEffect(() => {
    //     if (data) {
    //         setFormList(data);
    //     }
    // }, [data]);

    useEffect(() => {
        if (open) {
            setSelectedIds([]);
        }
    }, [open]);

    const handleClose = () => {
        close(false);
    };

    const handleSelect = (id, checked) => {
        if (checked) {
            setSelectedIds((prev) => [...prev, id]);
        } else {
            setSelectedIds((prev) => prev.filter((item) => item !== id));
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedIds(formList.map((item) => item.id));
        } else {
            setSelectedIds([]);
        }
    };

    const handleConfirm = () => {
        const validSelectedIds = selectedIds.filter((id) => {
            const item = formList.find((f) => f.id === id);
            return item && item.flagConfirm === false;
        });

        if (validSelectedIds.length === 0) {
            message.warning("กรุณาเลือกรายการที่ยังไม่ได้คอนเฟิร์ม");
            return;
        }

        // console.log("validSelectedIds", validSelectedIds)
        onFinish(true, validSelectedIds);
    };

    // const handleConfirm = () => {
    //     if (selectedIds.length === 0) {
    //         message.warning("กรุณาเลือกรายการที่ต้องการคอนเฟิร์ม");
    //         return;
    //     }
    //     onFinish(true, selectedIds);
    // };

    const handleCancleConfirm = (value) => {
        onFinish(false, [value.id]);
    };

    const onFinish = (type, value) => {
        setLoading(true);

        // แปลงข้อมูลเป็น Array ของ Object
        // เช่น [{id: 1, typeReply: 1, confirm: true}, {id: 2, ...}]
        const payload = formList
            .filter(item => value.includes(item.id))
            .map(item => ({
                id: item.id,
                confirm: type,
                typeReply: item.typeReply
            }));

        axios.post(baseUrlAREA + CONFIRM_LETTER, payload, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    message.success("บันทึกสำเร็จ");
                    // Update UI State
                    setFormList(prev => prev.map(item => {
                        if (value.includes(item.id)) return { ...item, flagConfirm: type };
                        return item;
                    }));
                    setDayData(prev => prev.map(item => {
                        if (value.includes(item.id)) return { ...item, flagConfirm: type };
                        return item;
                    }));
                    loadData()
                    if (type === true) setSelectedIds([]);
                }
            })
            .catch((err) => {
                console.error(err);
                message.error("เกิดข้อผิดพลาด");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const renderFormContent = (item, index) => {
        return (
            <Form
                name={`form_${index}`}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ width: '100%' }}
                autoComplete="off"
            >
                <Divider orientation={'left'} style={{ margin: '0 0 10px 0' }}><b>ข้อมูลลูกค้า</b></Divider>
                <Form.Item label="ที่อยู่" style={{ margin: 0 }}>
                    {item?.ADDR} {item?.zipcode === "-" ? null : item?.zipcode}
                </Form.Item>
                <Form.Item label="รอบ" style={{ margin: 0 }}>
                    {item?.roundDate ? dayjs(item?.roundDate).format("DD-MM-YYYY") : "-"}
                </Form.Item>
                <Form.Item label="EMS ไป" style={{ margin: 0 }}>
                    {item?.parcelNo || '-'}
                </Form.Item>
                <Form.Item label="EMS กลับ" style={{ margin: 0 }}>
                    {item?.parcelNoResponse || '-'}
                </Form.Item>
                <Divider orientation={'left'} style={{ margin: '0 0 10px 0' }}><b>การจัดเก็บข้อมูล</b></Divider>
                <Form.Item
                    label="ประเภทตอบกลับ"
                    style={{ margin: 0 }}
                    validateStatus={!item.statusReply ? "error" : ""}
                >
                    <Radio.Group
                        value={item.statusReply ? parseInt(item.statusReply) : null}
                        disabled // ปิดการแก้ไขในหน้านี้ (ตามโค้ดเดิม)
                        options={[
                            { value: 1, label: 'ตอบกลับ' },
                            { value: 2, label: 'ตีกลับ' },
                            { value: 5, label: 'ตอบกลับ(เว็บ)' },
                            { value: 6, label: 'ตีกลับ(เว็บ)' }
                        ]}
                    />
                </Form.Item>
                <Form.Item
                    label="ประเภทจดหมาย"
                    style={{ margin: 0 }}
                    validateStatus={!item.typeReply ? "error" : ""}
                >
                    <Radio.Group
                        value={item.typeReply ? parseInt(item.typeReply) : null}
                        disabled
                        options={[
                            { value: 1, label: 'บอกกล่าว' },
                            { value: 2, label: 'สิทธิซื้อรถคืน' },
                            { value: 3, label: 'แจ้งราคาขายรถ' },
                            { value: 4, label: 'บอกเลิก' }
                        ]}
                    />
                </Form.Item>
                <Form.Item
                    label="วันที่จัดเก็บ"
                    style={{ margin: 0 }}
                    validateStatus={!item.dateReply ? "error" : ""}
                >
                    <DatePicker
                        style={{ width: '100%', color: 'black' }}
                        value={item.dateReply ? dayjs(item.dateReply) : null}
                        disabled
                    />
                </Form.Item>
                <Divider />
                <Col span={24} style={{ textAlign: 'end' }}>
                    <Button
                        type='primary'
                        loading={loading}
                        icon={<CloseCircleOutlined />}
                        style={{ backgroundColor: 'orange' }}
                        onClick={() => handleCancleConfirm(item)}
                    >
                        ยกเลิกคอนเฟิร์มจดหมาย
                    </Button>
                </Col>
            </Form>
        );
    };

    const collapseItems = formList.map((item, index) => ({
        key: index,
        label: (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                    checked={selectedIds.includes(item.id)}
                    onChange={(e) => handleSelect(item.id, e.target.checked)}
                    onClick={(e) => e.stopPropagation()} // ป้องกัน Collapse เด้ง
                    style={{ marginRight: 10 }}
                />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontWeight: 'bold' }}>{index + 1}. {item?.customerFullName} ({item?.CONTNO})</span>
                    <span style={{ fontSize: '12px', color: '#888' }}>
                        ประเภทสัญญา: {handleShowTYPE(item?.contractSchema)} |  {item?.customerTypeId === 0 ? "ผู้ทำสัญญา" : `คนค้ำ ${item?.customerTypeId}`}
                    </span>
                </div>
            </div>
        ),
        extra: (
            <>
                <Tag color={'cyan'}>
                    {handleShowTypeReply(item?.typeReply)}
                </Tag>
                <Tag color={getStatusColor(item?.flagConfirm ? "คอนเฟิร์มแล้ว" : "รอคอนเฟิร์ม")}>
                    {item?.flagConfirm ? "คอนเฟิร์มแล้ว" : "รอคอนเฟิร์ม"}
                </Tag>
            </>
        ),
        children: renderFormContent(item, index),
    }));

    console.log("selectedIds", selectedIds)

    return (
        <Modal
            title="คอนเฟิร์มจดหมาย"
            open={open}
            closable={false}
            footer={null}
            width={700}
        >
            <div style={{ paddingBottom: 10, marginBottom: 10, borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center' }}>
                <Checkbox
                    onChange={handleSelectAll}
                    checked={formList.length > 0 && selectedIds.length === formList.length}
                    indeterminate={selectedIds.length > 0 && selectedIds.length < formList.length}
                >
                    เลือกทั้งหมด ({selectedIds.length} / {formList.length})
                </Checkbox>
            </div>

            <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <Collapse
                    items={collapseItems}
                    defaultActiveKey={[0]}
                />
            </div>
            <Divider />
            <Col span={24} style={{ textAlign: 'end' }}>
                <Space>
                    <Button
                        type='primary'
                        danger
                        icon={<CloseOutlined />}
                        onClick={handleClose}
                    >
                        ปิด
                    </Button>
                    <Button
                        type='primary'
                        loading={loading}
                        icon={<CheckCircleOutlined />}
                        style={{ backgroundColor: 'green' }}
                        onClick={handleConfirm}
                        disabled={selectedIds.length === 0} // ปิดปุ่มถ้าไม่ได้เลือก
                    >
                        คอนเฟิร์ม ({selectedIds.length})
                    </Button>
                </Space>
            </Col>
        </Modal>
    );
};

export default ConfirmLetter;